import PropTypes from "prop-types";
import React from "react";
import { translator } from "../../utils/i18n";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import LanguageIcon from "@material-ui/icons/Language";
import Switch from "@material-ui/core/Switch";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import FileIcon from "@material-ui/icons/InsertDriveFileOutlined";
import ShareIcon from "@material-ui/icons/Share";
import CommentIcon from "@material-ui/icons/Comment";
import InfoIcon from "@material-ui/icons/Info";
import LocaleSwitcher from "../../components/LocaleSwitcher_old";
import Divider from "@material-ui/core/Divider";
import { useDispatch, useSelector } from "react-redux";
import {
  setNewslettersStatus,
  setRecallCommunication,
  setRecallDocument,
  setRecallShare,
  setRecallStatus
} from "../../utils/fetcher";
import { Tooltip } from "@material-ui/core";

function MySettings({ showConfigs }) {
  const dispatch = useDispatch();

  const infoUser = useSelector(state =>
    state.patientArea.infosUser ? state.patientArea.infosUser : []
  );

  const useRecall = useSelector(state =>
    state.patientArea.params ? state.patientArea.params.recall : false
  );
  const useNewsLetters = useSelector(state =>
    state.patientArea.params ? state.patientArea.params.newsletters : false
  );
  const useRecallDocument = useSelector(state =>
    state.patientArea.params ? state.patientArea.params.recallDocument : false
  );

  const useShare = useSelector(state =>
    state.patientArea.params ? state.patientArea.params.recallShare : false
  );

  const useCommunication = useSelector(state =>
    state.patientArea.params
      ? state.patientArea.params.recallCommunication
      : false
  );
  const handleToggle = () => {
    dispatch(setRecallStatus(infoUser.tel, !useRecall));
  };

  const handleNewsletter = () => {
    dispatch(setNewslettersStatus(infoUser.tel, !useNewsLetters));
  };

  const handleDocuments = event => {
    console.log(event.target.checked);
    dispatch(setRecallDocument(event.target.checked));
  };

  const handleShare = event => {
    dispatch(setRecallShare(event.target.checked));
  };

  const handleCommunication = event => {
    dispatch(setRecallCommunication(event.target.checked));
  };

  return (
    <>
      <h1 className="title-page">{translator()._("CP_MENU_PARAMETRES")}</h1>
      <List className="list-settings">
        <ListItem className="item-setting">
          <ListItemIcon>
            <LanguageIcon />
          </ListItemIcon>
          <ListItemText
            id="switch-list-label-language"
            primary={translator()._("W_LANGUAGE")}
          />
          <ListItemSecondaryAction>
            <LocaleSwitcher />
          </ListItemSecondaryAction>
        </ListItem>
        {showConfigs && (
          <>
            <Divider variant="inset" className="ml-0" component="li" />
            <ListItem className="item-setting">
              <ListItemIcon>
                <PhoneIcon />
              </ListItemIcon>
              <ListItemText
                id="switch-list-label-reminder-phone"
                primary={translator()._("W_DESACTIVER_RAPPEL_TEL")}
              />
              <ListItemSecondaryAction>
                <Switch
                  className="switch-custom"
                  edge="end"
                  onChange={handleToggle}
                  checked={useRecall ? useRecall : false}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-reminder-phone"
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem className="item-setting">
              <ListItemIcon>
                <EmailIcon />
              </ListItemIcon>
              <ListItemText
                id="switch-list-label-newsletter"
                primary={translator()._("W_SWITCH_NEWSLETTERS")}
              />
              <ListItemSecondaryAction>
                <Switch
                  className="switch-custom"
                  edge="end"
                  onChange={handleNewsletter}
                  checked={useNewsLetters ? useNewsLetters : false}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-newsletter"
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem className="item-setting">
              <ListItemIcon>
                <FileIcon />
              </ListItemIcon>
              <ListItemText id="switch-list-label-documents">
                {translator()._("W_SWITCH_DOCUMENTS")}
                <Tooltip
                  arrow
                  title="Recevoir par voie dématérialisée via l’onglet « Documents » de mon espace personnel, les documents que le professionnel de santé me recevant en consultation souhaite me communiquer."
                >
                  <InfoIcon
                    fontSize="small"
                    style={{ verticalAlign: "top", margin: "0 5px" }}
                  />
                </Tooltip>
              </ListItemText>

              <ListItemSecondaryAction>
                <Switch
                  className="switch-custom"
                  edge="end"
                  onChange={handleDocuments}
                  checked={useRecallDocument ? useRecallDocument : false}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-documents"
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem className="item-setting">
              <ListItemIcon>
                <ShareIcon />
              </ListItemIcon>
              <ListItemText id="switch-list-label-share">
                {translator()._("W_SWITCH_SHARE")}
                <Tooltip
                  arrow
                  title="J’autorise le partage de mes informations et de mon dossier patient entre l’ensemble de mes centres auprès desquels j’effectue une consultation"
                >
                  <InfoIcon
                    fontSize="small"
                    style={{ verticalAlign: "top", margin: "0 5px" }}
                  />
                </Tooltip>
              </ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  className="switch-custom"
                  edge="end"
                  onChange={handleShare}
                  checked={useShare ? useShare : false}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-share"
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem className="item-setting">
              <ListItemIcon>
                <CommentIcon />
              </ListItemIcon>
              <ListItemText id="switch-list-label-share">
                {translator()._("W_SWITCH_COMMUNICATIONS")}
                <Tooltip
                  arrow
                  title="J’accepte de recevoir des communications de tiers partenaires de mes centres (Pour en savoir plus, consultez la politique de confidentialité de vos centres)"
                >
                  <InfoIcon
                    fontSize="small"
                    style={{ verticalAlign: "top", margin: "0 5px" }}
                  />
                </Tooltip>
              </ListItemText>
              <ListItemSecondaryAction>
                <Switch
                  className="switch-custom"
                  edge="end"
                  onChange={handleCommunication}
                  checked={useCommunication ? useCommunication : false}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-newsletter"
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </>
        )}
      </List>
    </>
  );
}

MySettings.propTypes = {
  showConfigs: PropTypes.bool
};

export default MySettings;
